export interface ApplicantInfoParams {
}

const ApplicantInfo = ({
}: ApplicantInfoParams) => {
    return (
        <div>
            <p>
                ApplicantInfo
            </p>
        </div>
    );
};

export default ApplicantInfo;
